import PropTypes from "prop-types";
import React, { Component, useState } from "react";
import { FaArrowRight, FaInfoCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import "../../../assets_/_login.css";
import PhoneNumber from "../../../components/Inputs/PhoneNumber";
import Select from "react-select"; // Ensure you're using react-select
import OTP from "../../OTP/OTP";
import confetti from "canvas-confetti";
import { ArrowRight, ArrowRightAlt } from "@mui/icons-material";
import { ApiUrl } from "../../../config";

class RegisterForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
      role: "patient",
      nom: "",
      prenom: "",
      phone: "",
      dob: "",
      cin: "",
      sexe: null,
      username: "",
      password: "",
      confirmPassword: "",
      error: "",
      successMessage: "",
      otpSent: false,
      otpVerified: false,
      isSendingOtp: false,
      isVerifiyingOtp: false,
    };
  }

  // Handle input changes
  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  // Handle change for the "sexe" select dropdown
  //   handleSexeChange = (selectedOption) => {
  //     this.setState({ sexe: selectedOption.value });
  //   };

  // handleSexeChange = (selectedOption) => {
  //   this.setState({ sexe: selectedOption });
  // };

  // handleSexeChange = (selectedOption) => {
  //   this.setState({
  //     sexe: selectedOption,
  //     role: selectedOption.value === "homme" ? "tuteur" : "",
  //   });
  // };

  handleSexeChange = (selectedOption) => {
  this.setState({
    sexe: selectedOption,
    role: selectedOption.value === "homme" ? "tuteur" : "patient",
  });
};

  handlePhoneChange = (phone) => {
    const numericPhone = phone.replace(/\D/g, "").substring(0, 9);
    this.setState({ phone: numericPhone });
  };

  handleDobChange = (event) => {
    const dob = event.target.value;
    this.setState({ dob });
  };

  checkAge(dob) {
    const dobDate = new Date(dob);
    const currentDate = new Date();

    let age = currentDate.getFullYear() - dobDate.getFullYear();
    const m = currentDate.getMonth() - dobDate.getMonth();

    // If the birthday hasn't occurred yet this year, subtract 1 from the age
    if (m < 0 || (m === 0 && currentDate.getDate() < dobDate.getDate())) {
      age--;
    }

    // Return true if age is 18 or more, otherwise false
    return age >= 18;
  }

  ValidateForm = async () => {
    let errorMessage = "";

    // Validate based on current step
    if (this.state.currentStep === 1) {
      if (!this.state.role) {
        errorMessage = "Veuillez choisir votre rôle.";
      } else if (!this.state.nom) {
        errorMessage = "Veuillez entrer votre nom.";
      } else if (!this.state.prenom) {
        errorMessage = "Veuillez entrer votre prénom.";
      } else if (!this.state.phone) {
        errorMessage = "Veuillez entrer votre numéro de téléphone.";
      } else if (!this.state.dob) {
        errorMessage = "Veuillez entrer votre date de naissance.";
      } else if (!this.state.cin) {
        errorMessage = "Veuillez entrer votre CIN.";
      } else if (!this.state.sexe) {
        errorMessage = "Veuillez choisir votre sexe.";
      }

      if (this.state.phone) {
        const phoneRegex = /^\d{9}$/; // Adjust to require 10 digits
        if (!phoneRegex.test(this.state.phone)) {
          this.setState({
            error: "Le numéro de téléphone est invalide.",
          });
          return; // Prevent moving to the next step
        }
      }

      if (this.state.dob) {
        if (!this.checkAge(this.state.dob)) {
          this.setState({
            error: "Vous devez avoir au moins 18 ans pour vous inscrire!",
          });
          return;
        }
      }

      if (this.state.cin) {
        try {
          const response = await fetch(
            `${ApiUrl}check-citoyen`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({ cin: this.state.cin }),
            }
          );

          const result = await response.json();
          console.log(result);
          if (result.exists) {
            this.setState({
              error: result.message,
            });
            return; // Prevent moving to the next step
          }
        } catch (error) {
          this.setState({
            error: "Erreur Vérification de cin.",
          });
        }
      }


    } else if (this.state.currentStep === 2) {
      if (!this.state.username) {
        errorMessage = "Veuillez entrer un nom d'utilisateur.";
      } else if (!this.state.password) {
        errorMessage = "Veuillez entrer un mot de passe.";
      } else if (this.state.password !== this.state.confirmPassword) {
        errorMessage = "Les mots de passe ne correspondent pas.";
      }

      // Check if the username is a valid email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.state.username)) {
        this.setState({
          error: "Veuillez entrer une adresse email valide.",
        });
        return; // Prevent moving to the next step
      }

      // Check if the password is at least 8 characters
      if (this.state.password.length < 8) {
        this.setState({
          error: "Le mot de passe doit contenir au moins 8 caractères.",
        });
        return; // Prevent moving to the next step
      }

      // Check if passwords match
      if (this.state.password !== this.state.confirmPassword) {
        this.setState({
          error: "Les mots de passe ne correspondent pas.",
        });
        return; // Prevent moving to the next step
      }
    }

    if (errorMessage) {
      this.setState({ error: errorMessage });
      return;
    } else {
      this.setState({ error: "" });
      return true;
    }
  };

  validationDone = async () => {
    try {
      const ValidateFormSuccess = await this.ValidateForm();
      if (ValidateFormSuccess) {
        this.nextStep();
      }
    } catch (error) {
      this.setState({
        error: "Une Erreur de validation.",
      });
    }
  };

  nextStep = async () => {
    this.setState({ currentStep: this.state.currentStep + 1 });
  };

  prevStep = () => {
    let { currentStep } = this.state;
    currentStep = currentStep <= 1 ? 1 : currentStep - 1;
    this.setState({ currentStep });
  };

  // Handle form submission to the API

  handleSendOtp = async () => {
    const data = {
      role: this.state.role,
      nom: this.state.nom,
      prenom: this.state.prenom,
      dob: this.state.dob,
      phone: this.state.phone,
      cin: this.state.cin,
      sexe: this.state.sexe?.value,
      username: this.state.username,
      password: this.state.password,
      password_confirmation: this.state.confirmPassword,
    };

    try {
      const ValidateFormSuccess = await this.ValidateForm();
      if (ValidateFormSuccess) {
        this.setState({ isSendingOtp: true }); // Set loading to true when OTP starts sending

        const response = await fetch(
          `${ApiUrl}send-otp-citoyen`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(data),
          }
        );

        if (!response.ok) {
          // Handle validation or server errors
          const errors = await response.json();
          console.error("Validation Errors:", errors);
          this.setState({
            error: errors.errors.username || "Erreur lors de l'envoi de l'OTP",
            isSendingOtp: false,
          });
          return;
        }

        const result = await response.json();
        console.log("OTP Sent Success:", result);
        this.setState({
          otpSent: true,
          error: "",
          currentStep: this.state.currentStep + 1,
          successMessage:
            "OTP sent successfully. Please verify your Adresse Email",
          isSendingOtp: false,
        });
      }
    } catch (error) {
      console.error("Error:", error);
      this.setState({
        error: "Erreur de réseau, veuillez réessayer.",
        isSendingOtp: false,
      });
    }
  };

  // Handle OTP verification
  verifyOtp = async (otp) => {
    console.log(otp);
    const data = {
      otp: otp,
      email: this.state.username,
    };

    try {
      this.setState({ isVerifiyingOtp: true });
      const response = await fetch(`${ApiUrl}verify-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errors = await response.json();
        this.setState({
          successMessage: "",
          error: errors.error || "Invalid OTP or OTP expired.",
          isVerifiyingOtp: false,
        });
        return;
      }

      this.handleSubmit();
      this.setState({ isVerifiyingOtp: false });
    } catch (error) {
      this.setState({
        error: "Erreur de réseau, veuillez réessayer.",
        isVerifiyingOtp: false,
      });
    }
  };

  handleSubmit = async () => {
    const data = {
      role: this.state.role,
      nom: this.state.nom,
      prenom: this.state.prenom,
      dob: this.state.dob,
      phone: this.state.phone,
      cin: this.state.cin,
      sexe: this.state.sexe?.value,
      username: this.state.username,
      password: this.state.password,
      password_confirmation: this.state.confirmPassword,
    };

    console.log(data);

    try {
      const response = await fetch(`${ApiUrl}register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        // Handle validation or server errors
        const errors = await response.json();
        const errorMessage = errors?.errors
          ? Object.values(errors.errors).flat().join(" ")
          : errors?.error || "Une erreur s'est produite. Veuillez réessayer.";

        // Set the error message in state
        this.setState({ error: errorMessage });
        return; // Exit the function
      }

      const result = await response.json(); // Parse the successful response
      console.log("Success:", result);
      this.setState({
        successMessage: "Votre Compte a bien été créé avec succès.",
        error: "",
        currentStep: this.state.currentStep + 1,
      });
      this.triggerConfetti();
    } catch (error) {
      // Handle network or unexpected errors
      console.error("Error:", error);
    }
  };

  triggerConfetti = () => {
    confetti({
      particleCount: 200,
      spread: 70, // Spread angle of the confetti
      origin: { y: 0.6, x: 0.6 }, // The origin of the confetti animation (height)
    });
  };

  render() {
    const { otpSent, otpVerified } = this.state;

    const sexes = [
      { value: "homme", label: "Homme" },
      { value: "femme", label: "Femme" },
    ];

    return (
      <form action="#!">
        {/* Display error message */}
        {this.state.error && (
          <div className="alert alert-danger">{this.state.error}</div>
        )}

        {/* Show success message if OTP is sent */}
        {this.state.successMessage && (
          <div className="alert alert-success">{this.state.successMessage}</div>
        )}

        {/* Step 1: Personal Info */}
        {this.state.currentStep === 1 && (
          <div className="row">
            <div className="row mb-4">
              <div className="col-12">
                <label className="form-label me-3">
                  Vous êtes : <span className="text-danger  fw-bold">*</span>
                </label>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="role"
                    id="patient"
                    value="patient"
                    disabled={this.state.sexe?.value === "homme"} 
                    onChange={this.handleInputChange}
                    checked={this.state.role === "patient"} // Bind with state
                  />
                  <label className="form-check-label" htmlFor="patient">
                    Patiente
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="role"
                    id="tuteur"
                    value="tuteur"
                    onChange={this.handleInputChange}
                    checked={this.state.role === "tuteur"} // Bind with state
                  />
                  <label className="form-check-label" htmlFor="tuteur">
                    Tuteur
                  </label>
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="form-group">
                <label className="sr-only">
                  Nom <span className="text-danger  fw-bold">*</span>
                </label>
                <input
                  type="text"
                  name="nom"
                  value={this.state.nom}
                  onChange={this.handleInputChange}
                  className="form-control"
                  placeholder="Nom"
                />
              </div>
            </div>
            <div className="col-6">
              <div className="form-group mb-4">
                <label className="sr-only">
                  Prénom <span className="text-danger  fw-bold">*</span>
                </label>
                <input
                  type="text"
                  name="prenom"
                  value={this.state.prenom}
                  onChange={this.handleInputChange}
                  className="form-control"
                  placeholder="votre prénom"
                />
              </div>
            </div>

            <div className="col-6">
              <div className="form-group">
                <label className="sr-only">
                  N° Téléphone <span className="text-danger  fw-bold">*</span>
                </label>
                <PhoneNumber
                  name="phone"
                  onChange={this.handlePhoneChange}
                  number="0123456789"
                  label="Customer Support"
                />
              </div>
            </div>

            <div className="col-6">
              <div className="form-group">
                <label className="sr-only">
                  Date de Naissance{" "}
                  <span className="text-danger  fw-bold">*</span>
                </label>
                <input
                  type="date"
                  name="dob"
                  value={this.state.dob} // Bound to the state
                  onChange={this.handleDobChange} // This triggers the handler
                  className="form-control"
                  placeholder="DD/MM/YYYY"
                />
              </div>
            </div>

            <div className="col-6">
              <div className="form-group">
                <label className="sr-only">
                  CIN <span className="text-danger  fw-bold">*</span>
                </label>
                <input
                  type="text"
                  name="cin"
                  value={this.state.cin}
                  onChange={this.handleInputChange}
                  className="form-control"
                  placeholder="Cin"
                />
              </div>
            </div>

            <div className="col-6">
              <div className="form-group">
                <label className="sr-only">
                  Sexe <span className="text-danger  fw-bold">*</span>
                </label>
                <Select
                  options={sexes}
                  value={this.state.sexe} // Pass the selected object
                  onChange={this.handleSexeChange}
                  placeholder="Select your sexe"
                />
              </div>
            </div>
          </div>
        )}

        {/* Step 2: Account Info */}
        {this.state.currentStep === 2 && (
          <div className="row">
            <div className="col-10">
              <div className="form-group">
                <label className="sr-only">Adresse email</label>
                <input
                  type="text"
                  name="username"
                  value={this.state.username}
                  onChange={this.handleInputChange}
                  className="form-control"
                  placeholder="Votre adresse Email"
                />
              </div>
            </div>

            <div className="col-10">
              <div className="form-group">
                <label className="sr-only">Mot de passe</label>
                <input
                  type="password"
                  name="password"
                  value={this.state.password}
                  onChange={this.handleInputChange}
                  className="form-control"
                  placeholder="Mot de passe"
                />
              </div>
            </div>

            <div className="col-10">
              <div className="form-group">
                <label className="sr-only">Confirmer mot de passe</label>
                <input
                  type="password"
                  name="confirmPassword"
                  value={this.state.confirmPassword}
                  onChange={this.handleInputChange}
                  className="form-control"
                  placeholder="Confirmer mot de passe"
                />
              </div>
            </div>
          </div>
        )}

        {this.state.currentStep === 3 && (
          <div className="text-center">
            {otpSent && !otpVerified && <OTP onVerifyOtp={this.verifyOtp} />}
          </div>
        )}

        {this.state.currentStep === 4 && (
          <div className="  text-center">
            <img
              src="assets/img/illustration/register success.png"
              alt="Registration Success"
              className="congratulation-img"
              style={{ width: "50%", maxWidth: "300px" }}
            />
          </div>
        )}

        {/* Navigation Buttons */}
        <div className="form-group">
          {this.state.currentStep > 1 && this.state.currentStep < 3 && (
            <button
              type="button"
              className="btn btn-white mr-3 login-btn"
              onClick={this.prevStep}
            >
              Précédent
            </button>
          )}

          {this.state.currentStep === 2 && (
            <button
              type="button"
              className="btn btn-primary login-btn"
              onClick={() => {
                this.ValidateForm();
                this.handleSendOtp();
              }}
              disabled={this.state.isSendingOtp}
            >
              {this.state.isSendingOtp ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span> // Show loader
              ) : (
                "Suivant"
              )}
            </button>
          )}

          {this.state.currentStep < 3 && this.state.currentStep !== 2 && (
            <button
              type="button"
              className="btn btn-primary login-btn"
              onClick={() => {
                this.ValidateForm();
                this.validationDone();
              }}
            >
              Suivant
            </button>
          )}

          {this.state.currentStep === 4 && (
            <div className="text-center">
              <Link
                to="/login"
                type="button"
                className="btn btn-primary login-btn"
              >
                Se connecter
              </Link>
            </div>
          )}
        </div>
      </form>
    );
  }
}

export default RegisterForm;
